<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
          >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>配置中心</el-breadcrumb-item>
          <el-breadcrumb-item>首页轮播</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" label-width="68px">
          <el-form-item style="width: 100%; display: flex; justify-content: flex-end">
            <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
            :data="bannerList"
            :header-cell-style="tableStyle.headerStyle"
            :cell-style="tableStyle.cellStyle"
            border
            height="550">
          <el-table-column label="序号" type="index" align="center" width="50">
            <template slot-scope="scope">
          <span>{{
              (queryParams.pageNum - 1) * queryParams.pageSize + scope.$index + 1
            }}</span>
            </template>
          </el-table-column>
          <el-table-column label="标题" align="center" prop="title" />
          <el-table-column label="图片(中文)" align="center" prop="facilitiesImg" width="150">
            <template slot-scope="scope">
              <img @click="imgclick(scope.row.facilitiesImg, true)" v-if="scope.row.facilitiesImg && scope.row.facilitiesImg.length > 0"
                   :src="scope.row.facilitiesImg" alt="" class="list-image" />
              <img v-else src="@/assets/images/default.png" alt="" class="list-image" />
            </template>
          </el-table-column>
          <el-table-column label="图片(日语)" align="center" prop="facilitiesImgJa" width="150">
            <template slot-scope="scope">
              <img @click="imgclick(scope.row.facilitiesImgJa, true)" v-if="
              scope.row.facilitiesImgJa && scope.row.facilitiesImgJa.length > 0
            " :src="scope.row.facilitiesImgJa" alt="" class="list-image" />
              <img v-else src="@/assets/images/default.png" alt="" class="list-image" />
            </template>
          </el-table-column>
          <el-table-column label="链接地址" align="left" prop="linkImg" />
          <el-table-column label="最后编辑时间" align="center" prop="updateTime" width="100">
            <template v-slot="scope">
              <span>{{ scope.row.updateTime  | dateFormatToDay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="排序值" align="center" prop="sortKey" width="90" sortable />
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdate(scope.row)">编辑</el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[5, 10, 20, 50, 100, 200]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
      </div>
    </table-con>
    <!-- 添加或修改轮播图管理对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="750px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="left" label-suffix=":">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="设施图片(中文)" prop="facilitiesImg">
          <el-upload
              :http-request="customRequest"
              :limit="1"
              :file-list="fileList1"
              list-type="picture-card"
              :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="el-upload__tip">{{ imageMessageTwo }}</div>
<!--          <image-upload v-model="form.facilitiesImg" :message="imageMessageTwo" :limit="1" :fileSize="2" />-->
        </el-form-item>
        <el-form-item label="设施图片(日语)" prop="facilitiesImgJa">
          <el-upload
              :http-request="customRequest2"
              :limit="1"
              :file-list="fileList2"
              list-type="picture-card"
              :on-remove="handleRemove2"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <div class="el-upload__tip">{{ imageMessageTwo }}</div>
<!--          <image-upload v-model="form.facilitiesImgJa" :message="imageMessageTwo" :limit="1" :fileSize="2" />-->
        </el-form-item>
        <el-form-item label="链接地址" prop="linkImg">
          <el-input v-model="form.linkImg" placeholder="请输入链接地址" />
        </el-form-item>
        <el-form-item label="排序值" prop="sortKey">
          <el-input v-model="form.sortKey" placeholder="请输入排序值" />
        </el-form-item>
<!--        <el-form-item label="状态" prop="bannerStatus">-->
<!--          <el-switch v-model="form.bannerStatus" active-value="0" inactive-value="1"></el-switch>-->
<!--        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
import axios from "axios";
import { getToken } from "@/utils/auth";
export default {
  name: 'userIngredients',
  // name: 'configuration/UserIngredients',
  components: { tableCon },
  data() {
    return {
      fileList1: [],
      fileList2: [],
      visible: false,
      imgurl: "",
      imageMessage:
          "请上传一张图片，上传图片尺寸推荐750*450px，图片大小不超过2M、其它尺寸可能会被拉伸",
      imageMessageTwo:
          "请上传一张图片，上传图片推荐尺寸比为2:1，图片大小不超过2M、其它尺寸可能会被拉伸",
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 轮播图管理表格数据
      bannerList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        title: null,
        facilitiesImg: null,
        facilitiesImgJa: null,
        facilitiesImgKr: null,
        linkImg: null,
        sortKey: null,
        bannerStatus: null,
        createUserId: null,
        createUserName: null,
        updateUserId: null,
        updateUserName: null,
      },
      // 表单参数
      form: {
        bannerStatus: "0",
      },
      // 表单校验
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        linkImg: [{ required: true, message: "请输入链接", trigger: "blur" }],
        sortKey: [
          { required: true, message: "请输入排序值", trigger: "blur" },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            message: "只能输入正整数",
            trigger: "blur",
          },
        ],
        facilitiesImg: [
          { required: true, message: "请上传图片", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (
                  this.form.facilitiesImg &&
                  this.form.facilitiesImg.length > 0
              ) {
                callback()
              } else {
                callback(new Error("请上传图片"))
              }
            },
            trigger: "blur",
          },
        ],
        facilitiesImgJa: [
          { required: true, message: "请上传图片", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (
                  this.form.facilitiesImgJa &&
                  this.form.facilitiesImgJa.length > 0
              ) {
                callback()
              } else {
                callback(new Error("请上传图片"))
              }
            },
            trigger: "blur",
          },
        ],
        facilitiesImgEn: [
          { required: true, message: "请上传图片", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (
                  this.form.facilitiesImgEn &&
                  this.form.facilitiesImgEn.length > 0
              ) {
                callback()
              } else {
                callback(new Error("请上传图片"))
              }
            },
            trigger: "blur",
          },
        ],
        facilitiesImgKr: [
          { required: true, message: "请上传图片", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (
                  this.form.facilitiesImgEn &&
                  this.form.facilitiesImgEn.length > 0
              ) {
                callback()
              } else {
                callback(new Error("请上传图片"))
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    handleRemove(){
      this.form.facilitiesImg = ''
    },
    async customRequest(options){
      const formData = new FormData()
      formData.append('file', options.file)
      try {
        let a = process.env.VUE_APP_BASE_DOMAIN + process.env.VUE_APP_BASE_API
        const response = await axios.post(a + '/aliyun/oss/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ` + getToken()
          },
        })
        this.form.facilitiesImg = response.data.data
      } catch (error) {
        console.log('error',error)
      }
    },

    handleRemove2(){
      this.form.facilitiesImgJa = ''
    },
    async customRequest2(options){
      const formData = new FormData()
      formData.append('file', options.file)
      try {
        let a = process.env.VUE_APP_BASE_DOMAIN + process.env.VUE_APP_BASE_API
        const response = await axios.post(a + '/aliyun/oss/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ` + getToken()
          },
        })
        this.form.facilitiesImgJa = response.data.data
      } catch (error) {
        console.log('error',error)
      }
    },
    handleSizeChange(pageSize) {
      this.queryParams.pageSize = pageSize;
      this.getList();
    },
    handleCurrentChange(pageNumber) {
      this.queryParams.pageNum = pageNumber;
      this.getList();
    },
    /** 查询轮播图管理列表 */
    async getList () {
      // this.loading = true
      const res = await this.$http.get("system/banner/list", {
        params: this.queryParams,
      });
      console.log(res)
        this.bannerList = res.data.data.list
        this.total = res.data.data.total
      // listBanner(this.queryParams).then((response) => {
      //   this.bannerList = response.rows
      //   this.total = response.total
      //   this.loading = false
      // })
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: null,
        title: null,
        facilitiesImg: null,
        facilitiesImgJa: null,
        linkImg: null,
        sortKey: null,
        delFlag: null,
        bannerStatus: "0",
        createTime: null,
        createUserId: null,
        createUserName: null,
        updateTime: null,
        updateUserId: null,
        updateUserName: null,
      }
      // this.resetForm("form")
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.open = true
      this.title = "添加轮播图管理"
      this.fileList1 = []
      this.fileList2 = []
    },
    /** 修改按钮操作 */
    async handleUpdate (row) {
      this.reset()
      const id = row.id || this.ids
      const res = await this.$http.get(`system/banner/${id}`);
      console.log('res',res)
      this.form = res.data.data
        this.open = true
        this.title = "修改轮播图管理"
      this.fileList1 = [
        {
          url: res.data.data.facilitiesImg
        }
      ]
      this.fileList2 = [
        {
          url: res.data.data.facilitiesImgJa
        }
      ]
      // getBanner(id).then((response) => {
      //   this.form = response.data
      //   this.open = true
      //   this.title = "修改轮播图管理"
      // })
    },
    /** 提交按钮 (中文)*/
    submitForm () {
      console.log(this.form)
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.form.id != null) {
            const params = { ...this.form }
            const res = await this.$http.put("system/banner", params);
            console.log(res)
              this.open = false
              this.getList()
          } else {
            const params = { ...this.form }
            const res = await this.$http.post("system/banner", params);
            console.log(res)
              this.open = false
              this.getList()
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      const ids = row.id || this.ids
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.delete(`system/banner/${ids}`);
        console.log(res)
        this.getList()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      // this.$modal
      //     .confirm("是否确认删除轮播图的数据项？")
      //     .then(function () {
      //       return delBanner(ids)
      //     })
      //     .then(() => {
      //       this.getList()
      //       this.$modal.msgSuccess("删除成功")
      //     })
      //     .catch(() => { })
    },
    imgclick (url) {
      //图片放大
      this.visible = true
      this.imgurl = url
    },
  },

  created() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
// .el-dialog{
//   height: 80% !important;
//   overflow: auto !important;
// }
.el-upload__tip {
  font-size: 12px;
  color: #ff0000;
  margin-top: 7px;
}
</style>
